import { AxisBankLogoIcon, EaseBuzzIcon, StanPeLogoIcon, IdbiLogoIcon } from 'utils/icons';
import Watermark from 'assets/icons/watermark.svg';

const PORTAL_THEME = {
  160560: {
    colorPrimary: '#509CDA',
    colorFillAlter: '#EEFEFE',
    logo: <StanPeLogoIcon />,
    backGroundWaterMark: null
  },
  92420: {
    // testing partner Id.
    colorPrimary: '#509CDA',
    colorFillAlter: '#EEFEFE',
    logo: <StanPeLogoIcon />,
    backGroundWaterMark: null
  },
  220816: {
    colorPrimary: '#97144D',
    colorFillAlter: '#97144D0D',
    logo: <AxisBankLogoIcon />,
    backGroundWaterMark: null
  },
  4486: {
    // testing partner Id.
    colorPrimary: '#03826B',
    colorFillAlter: '#e6fefa',
    logo: <IdbiLogoIcon />,
    backGroundWaterMark: null
  },
  default: {
    colorPrimary: '#6D44E5',
    colorFillAlter: '#8244e524',
    logo: <EaseBuzzIcon />,
    backGroundWaterMark: Watermark
  }
};

export default PORTAL_THEME;
